
import { defineComponent } from "vue";
import store from "@/store";

import AddIcon from "@/assets/icons/add.svg?inline";
import HeartIcon from "@/assets/icons/heart.svg?inline";
import MessengerIcon from "@/assets/icons/messenger.svg?inline";
import MoreIcon from "@/assets/icons/more-horizontal.svg?inline";
import CommentIcon from "@/assets/icons/comment.svg?inline";
import ShareIcon from "@/assets/icons/share.svg?inline";
import BookmarkIcon from "@/assets/icons/bookmark.svg?inline";

import HomeIcon from "@/assets/icons/home.svg?inline";
import SearchIcon from "@/assets/icons/search.svg?inline";
import ReelsIcon from "@/assets/icons/reels.svg?inline";
import ShopIcon from "@/assets/icons/shopping-bag.svg?inline";

import dayjs from "dayjs";

function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default defineComponent({
  name: "Home",
  components: {
    AddIcon,
    HeartIcon,
    MessengerIcon,
    MoreIcon,
    CommentIcon,
    ShareIcon,
    BookmarkIcon,
    HomeIcon,
    SearchIcon,
    ReelsIcon,
    ShopIcon,
  },
  computed: {
    author() {
      return store.state.author;
    },
    post() {
      return store.state.post;
    },
    likes() {
      return store.state.likes;
    },
    numberOfComments() {
      return store.state.numberOfComments;
    },
    profileAvatar() {
      return store.state.profileAvatar;
    },
  },
  data() {
    return {
      numberWithCommas,
      dayjs,
    };
  },
  methods: {},
});
